<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent: 00em;">I have scribbled stories for years, but it was not until I joined the Waveney Author Group that I achieved my ambition to be published. I would like to say an enormous thank you to Suzan Collins for all her kindness, support and practical help. Thank you also to the other members of WAG. I would also like to thank Pat for proofreading my novel.</p><br/>
<p style="text-indent: 00em;">And finally, the biggest thanks of all goes to my dear husband, John, for all his hard work and support, especially on the technical side.</p>
<p style="text-indent: 00em;">Cover: John Sayer</p>
<p style="text-indent: 00em;">Editor: Alex Matthews</p>
<p style="text-indent: 00em;">www.bookeditingservices.co.uk</p>
<p style="text-indent: 00em;">Reader Pat Vellacott</p><br/>
<p style="text-indent: 00em;">The places featured in <em>The PepperAsh Clinch</em> are all fictional, although there may be a passing resemblance to towns and villages around the coastal area of the Suffolk/Norfolk border. The characters, personalities and their predicaments are also completely fictional.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?cf53cf0a